function increment() {
    var counter = document.getElementById('counter');

    counter.value = Number(counter.value) + 1;
}

function decrement() {
    var counter = document.getElementById('counter');

    if(Number(counter.value) == 1)
        return;
        
    counter.value = Number(counter.value) - 1;
}

function AddProductToCart(id, message) {
    let counter = document.getElementById('counter');

    if(Number(counter.value) < 1)
        return;

    let spinner = document.getElementById('add-spinner');
    spinner.style.display = 'inline-block';

    AddToCart(id, Number(counter.value), spinner, message);
}

var slideShow = document.querySelector(".slideshow-container");

slideShow.addEventListener("touchstart", startTouch, false);
slideShow.addEventListener("touchmove", moveTouch, false);

  // Swipe Up / Down / Left / Right
  var initialX = null;
  var initialY = null;

  function startTouch(e) {
    initialX = e.touches[0].clientX;
    initialY = e.touches[0].clientY;
  };

  function moveTouch(e) {
    if (initialX === null) {
      return;
    }

    if (initialY === null) {
      return;
    }

    var currentX = e.touches[0].clientX;
    var currentY = e.touches[0].clientY;

    var diffX = initialX - currentX;
    var diffY = initialY - currentY;

    if (Math.abs(diffX) > Math.abs(diffY)) {
      // sliding horizontally
      if (diffX > 0) {
        // swiped left
        plusSlides(1);
      } else {
        // swiped right
        plusSlides(-1);
      }  
    }

    initialX = null;
    initialY = null;

    e.preventDefault();
  };
